var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project.objectID)?_c('file-editor',{attrs:{"file":_vm.file,"projectId":_vm.project.objectID},on:{"save":function($event){return _vm.update(false)},"save-and-exit":function($event){return _vm.update(true)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }